module.exports = __webpack_public_path__ + "media/whats_your_status_series/tutorial-bullet-2750fe6a.png";